export const newTask = {
  id: Date.now().toString,
  name: "unknown",
  duration: 0,
  valid: true,
  complete: 0,
  category: "Other Action",
  function: "",
};

export const tasks = [
  {
    ...newTask,
    name: "Open Lid",
    duration: 19,
    type: "open_lid",
    cookIn: "",
    category: "Nutripot Action",
    function: "lidOpen",
    code: `await lidOpen(this.utensil);`,
  },
  {
    ...newTask,
    name: "Close Lid",
    duration: 22,
    type: "close_lid",
    cookIn: "",
    category: "Nutripot Action",
    function: "lidClose",
    code: `await lidClose(this.utensil);`,
  },
  {
    ...newTask,
    name: "Dispense Grain",
    duration: 30,
    type: "choose_grains",
    position: "",
    item_name: "",
    quantity: "",
    unit: "g",
    category: "Dispenser Action",
    function: "dispenseGrain",
    code: `await dispenseGrain($grain_box, $grain_w);`,
  },
  {
    ...newTask,
    name: "Dispense Spice",
    duration: 30,
    type: "choose_spices",
    position: "",
    item_name: "",
    quantity: "",
    unit: "g",
    category: "Dispenser Action",
    function: "dispensePowder",
    code: `await dispensePowder($spice_box, $spice_w);`,
  },
  {
    ...newTask,
    name: "Pour Grains Cup",
    duration: 40,
    type: "pour_grain",
    cookIn: "",
    category: "Pour Action",
    function: "pourGrainCup",
    code: `await homeGrain();
    await pourGrainCup(this.utensil);
   `,
  },
  {
    ...newTask,
    name: "Pour Spices Cup",
    duration: 40,
    type: "pour_spice",
    cookIn: "",
    category: "Pour Action",
    function: "pourPowderCup",
    code: `await homePowder();
    await pourPowderCup(this.utensil);`,
  },

  {
    ...newTask,
    name: "Pour Manual Station Bowl",
    duration: 50,
    args: { pos: 0 },
    type: "choose_bowl",
    position: "",
    item_name: "",
    quantity: "",
    unit: "g",
    cookIn: "",
    category: "Pour Action",
    function: "pourBowl",
    code: `await pourBowl($bowl_no,this.utensil);`,
  },
  {
    ...newTask,
    name: "Pour Manual Station Cup",
    duration: 50,
    args: { pos: 0 },
    type: "choose_cup",
    position: "",
    item_name: "",
    quantity: "",
    unit: "g",
    cookIn: "",
    category: "Pour Action",
    function: "pourWhiteCup",
    code: `await pourWhiteCup($cup_no,this.utensil);`,
  },
  {
    ...newTask,
    name: "Add Oil",
    duration: 50,
    type: "choose_oil",
    position: "",
    item_name: "",
    quantity: "",
    unit: "ml",
    cookIn: "",
    category: "Pour Action",
    function: "pourOil",
    code: `await pourOil('$bottle_oil', $bottle_ml, this.utensil),`,
  },
  {
    ...newTask,
    name: "Pour Strainer",
    duration: 40,
    cookIn: "",
    type: "pour_soaks",
    category: "Pour Action",
    function: "pourStainer",
    code: `await pourStainer(this.utensil);`,
  },
  {
    ...newTask,
    name: "Add Sauce/Paste",
    duration: 50,
    type: "choose_paste",
    position: "",
    item_name: "",
    quantity: "",
    unit: "tea spoon",
    cookIn: "",
    category: "Pour Action",
    function: "pourPaste",
    code: `await pourPaste(this.utensil, $squeeze_times);`,
  },
  {
    ...newTask,
    name: "Add Water",
    duration: 40,
    type: "choose_water",
    position: "",
    item_name: "",
    quantity: "",
    unit: "ml",
    cookIn: "",
    category: "Pour Action",
    function: "pourWater",
    code: `await pourWater($water_ml, this.utensil);`,
  },
  {
    ...newTask,
    name: "Soak Grain",
    duration: 40,
    position: "",
    item_name: "",
    type: "choose_soaks",
    quantity: "",
    unit: "g",
    cookIn: "",
    category: "Dispenser Action",
    function: "pourGrainCupToStainer",
    code: `await dispenseGrain($grain_box, $grain_w); await homeGrain(); await pourGrainCupToStainer(this.utensil, 60);`,
  },
  // {
  //   ...newTask,
  //   name: "Mixed Grains Pour to Soak",
  //   duration: 40,
  //   position: "",
  //   item_name: "",
  //   type: "pour_soaks_strainer",
  //   quantity: "",
  //   unit: "g",
  //   cookIn: "",
  //   category: "Pour Action",
  //   function: "pourGrainCupToStainer",
  //   code: `await homeGrain();  await pourGrainCupToStainer(this.utensil, 60);`,
  // },
  {
    ...newTask,
    name: "Do Stir",
    duration: 60,
    type: "choose_stir",
    cookIn: "",
    quantity: "",
    unit: "times",
    category: "Stir Action",
    code: `await stirManually(this.utensil, $stir_times,$stir_speed);`,
  },
  {
    ...newTask,
    name: "Cook/Wait For (Time)",
    duration: 50,
    type: "choose_seconds",
    cookIn: "",
    quantity: "",
    unit: "second",
    category: "Waiting Action",
    code: `await waitFor($wait_second);`,
  },
  {
    ...newTask,
    name: "Steam Release",
    duration: 20,
    type: "release_steam",
    cookIn: "",
    category: "Nutripot Action",
    code: `await releaseSteam(this.utensil);`,
  },
  {
    ...newTask,
    name: "Heat On",
    duration: 1,
    type: "heat_on",
    cookIn: "",
    level: "on",
    category: "Nutripot Action",
    code: `await setHeat('manual',this.utensil);`,
  },
  {
    ...newTask,
    name: "Saute",
    duration: 1,
    type: "heat_on",
    cookIn: "",
    level: "on",
    category: "Nutripot Action",
    code: `await setHeat('saute',this.utensil);`,
  },
  {
    ...newTask,
    name: "Heat Off",
    duration: 1,
    type: "heat_off",
    cookIn: "",
    level: "off",
    category: "Nutripot Action",
    code: `await setHeat('off',this.utensil);`,
  },
  // {
  //   ...newTask,
  //   name: "Chimney Off",
  //   duration: 15,
  //   type: "none",
  //   cookIn: "",
  //   level: 0,
  //   category: "Chimney Action",
  //   code: `await chimny(0);`,
  // },
  // {
  //   ...newTask,
  //   name: "Chimney On",
  //   duration: 15,
  //   type: "none",
  //   cookIn: "",
  //   level: 1,
  //   category: "Chimney Action",
  //   code: `await chimny(1);`,
  // },
];
export const cookingTasks = [
  {
    ...newTask,
    name: "Open Lid",
    duration: 19,
    type: "open_lid",
    cookIn: "",
    category: "Nutripot Action",
    function: "lidOpen",
    code: `await lidOpen(this.utensil);`,
  },
  {
    ...newTask,
    name: "Close Lid",
    duration: 22,
    type: "close_lid",
    cookIn: "",
    category: "Nutripot Action",
    function: "lidClose",
    code: `await lidClose(this.utensil);`,
  },
  {
    ...newTask,
    name: "Dispense Grain",
    duration: 30,
    type: "choose_grains",
    position: "",
    item_name: "",
    quantity: "",
    unit: "g",
    category: "Dispenser Action",
    function: "dispenseGrain",
    code: `await dispenseGrain($grain_box, $grain_w);`,
  },
  {
    ...newTask,
    name: "Dispense Spice",
    duration: 30,
    type: "choose_spices",
    position: "",
    item_name: "",
    quantity: "",
    unit: "g",
    category: "Dispenser Action",
    function: "dispensePowder",
    code: `await dispensePowder($spice_box, $spice_w);`,
  },
  {
    ...newTask,
    name: "Pour Grains Cup",
    duration: 40,
    type: "pour_grain",
    cookIn: "",
    category: "Pour Action",
    function: "pourGrainCup",
    code: `await homeGrain();
    await pourGrainCup(this.utensil);
   `,
  },
  {
    ...newTask,
    name: "Pour Spices Cup",
    duration: 40,
    type: "pour_spice",
    cookIn: "",
    category: "Pour Action",
    function: "pourPowderCup",
    code: `await homePowder();
    await pourPowderCup(this.utensil);`,
  },

  {
    ...newTask,
    name: "Pour Manual Station Bowl",
    duration: 50,
    args: { pos: 0 },
    type: "choose_bowl",
    position: "",
    item_name: "",
    quantity: "",
    unit: "g",
    cookIn: "",
    category: "Pour Action",
    function: "pourBowl",
    code: `await pourBowl($bowl_no,this.utensil);`,
  },
  {
    ...newTask,
    name: "Pour Manual Station Cup",
    duration: 50,
    args: { pos: 0 },
    type: "choose_cup",
    position: "",
    item_name: "",
    quantity: "",
    unit: "g",
    cookIn: "",
    category: "Pour Action",
    function: "pourWhiteCup",
    code: `await pourWhiteCup($cup_no,this.utensil);`,
  },
  {
    ...newTask,
    name: "Add Oil",
    duration: 50,
    type: "choose_oil",
    position: "",
    item_name: "",
    quantity: "",
    unit: "ml",
    cookIn: "",
    category: "Pour Action",
    function: "pourOil",
    code: `await pourOil('$bottle_oil', $bottle_ml, this.utensil),`,
  },
  {
    ...newTask,
    name: "Pour Strainer",
    duration: 40,
    cookIn: "",
    type: "pour_soaks",
    category: "Pour Action",
    function: "pourStainer",
    code: `await pourStainer(this.utensil);`,
  },
  {
    ...newTask,
    name: "Add Sauce/Paste",
    duration: 50,
    type: "choose_paste",
    position: "",
    item_name: "",
    quantity: "",
    unit: "tea spoon",
    cookIn: "",
    category: "Pour Action",
    function: "pourPaste",
    code: `await pourPaste(this.utensil, $squeeze_times);`,
  },
  {
    ...newTask,
    name: "Add Water",
    duration: 40,
    type: "choose_water",
    position: "",
    item_name: "",
    quantity: "",
    unit: "ml",
    cookIn: "",
    category: "Pour Action",
    function: "pourWater",
    code: `await pourWater($water_ml, this.utensil);`,
  },
  {
    ...newTask,
    name: "Soak Grain",
    duration: 40,
    position: "",
    item_name: "",
    type: "choose_soaks",
    quantity: "",
    unit: "g",
    cookIn: "",
    category: "Dispenser Action",
    function: "pourGrainCupToStainer",
    code: `await dispenseGrain($grain_box, $grain_w); await homeGrain(); await pourGrainCupToStainer(this.utensil, 60);`,
  },
  // {
  //   ...newTask,
  //   name: "Mixed Grains Pour to Soak",
  //   duration: 40,
  //   position: "",
  //   item_name: "",
  //   type: "pour_soaks_strainer",
  //   quantity: "",
  //   unit: "g",
  //   cookIn: "",
  //   category: "Pour Action",
  //   function: "pourGrainCupToStainer",
  //   code: `await homeGrain(); await pourGrainCupToStainer(this.utensil, 60);`,
  // },
  {
    ...newTask,
    name: "Do Stir",
    duration: 60,
    type: "choose_stir",
    cookIn: "",
    quantity: "",
    unit: "times",
    category: "Stir Action",
    code: `await stirManually(this.utensil, $stir_times,$stir_speed);`,
  },
  {
    ...newTask,
    name: "Cook/Wait For (Time)",
    duration: 50,
    type: "choose_seconds",
    cookIn: "",
    quantity: "",
    unit: "second",
    category: "Waiting Action",
    code: `await waitFor($wait_second);`,
  },
  {
    ...newTask,
    name: "Steam Release",
    duration: 20,
    type: "release_steam",
    cookIn: "",
    category: "Nutripot Action",
    code: `await releaseSteam(this.utensil);`,
  },
  {
    ...newTask,
    name: "Heat On",
    duration: 1,
    type: "heat_on",
    cookIn: "",
    level: "on",
    category: "Nutripot Action",
    code: `await setHeat('manual',this.utensil);`,
  },
  {
    ...newTask,
    name: "Saute",
    duration: 1,
    type: "heat_on",
    cookIn: "",
    level: "on",
    category: "Nutripot Action",
    code: `await setHeat('saute',this.utensil);`,
  },
  {
    ...newTask,
    name: "Heat Off",
    duration: 1,
    type: "heat_off",
    cookIn: "",
    level: "off",
    category: "Nutripot Action",
    code: `await setHeat('off',this.utensil);`,
  },
  {
    ...newTask,
    name: "Chimney Off",
    duration: 15,
    type: "chimney_off",
    cookIn: "",
    level: 0,
    category: "Chimney Action",
    code: `await chimny(0);`,
  },
  {
    ...newTask,
    name: "Chimney On",
    duration: 15,
    type: "chimney_on",
    cookIn: "",
    level: 1,
    category: "Chimney Action",
    code: `await chimny(1);`,
  },
];
